<template>
    <div ref="detailSidebar" class="detail-sidebar" :class="{is_fixed: isFixed}">
        <div class="sidebar-fever clearfix">
            <div class="sidebar-fever-left">
                <!-- 展示价格 start -->
                <template>
                    <promotion-price v-if="promotionUrgeInfo" :res="res" :urge-info="promotionUrgeInfo" />
                    <boss-price v-else :res="res" />
                </template>
                <!-- 展示价格 end -->
            </div>
            <detail-share v-if="!isGtqscz" :res="res" />
        </div>
        <urge-info v-if="promotionUrgeInfo && promotionUrgeInfo.promotionCountDown" :urge-info="promotionUrgeInfo" />
        <div v-if="res.display_detail!=1" class="sidebar-explain">
            <div v-if="res.tag_list && res.tag_list.length > 0" class="sidebar-explain__dl clearfix">
                <div class="sidebar-explain__dt">服务:</div>
                <div class="sidebar-explain__dd">
                    <span
                        v-for="(item, index) in res.tag_list"
                        :key="index"
                        class="service"
                    >{{item.tag_title}}</span>
                </div>
            </div>
            <div v-if="res.materail_delivery && res.biz_type !== adultType" class="sidebar-explain__dl clearfix">
                <div class="sidebar-explain__dt">说明:</div>
                <div class="sidebar-explain__dd">
                    若退课时讲义已寄出，需扣除相应的邮寄及工本费用。
                    <br>正价课仅支持电脑客户端和手机客户端观看，电脑客户端不支持Windows Xp、Mac OS10.09及以下版本，需升级电脑系统后上课。
                </div>
            </div>
            <template v-if="res.criss_target_course && token && res.content_type != 1">
                <div class="sidebar-explain__dl clearfix">
                    <div class="sidebar-explain__dt">提示:</div>
                    <div v-if="res.criss_course" class="sidebar-explain__dd criss">该课程仅限未购买过2019春季二年级语文正价课学员购买</div>
                    <div v-else class="sidebar-explain__dd criss">恭喜你获得9月购课权益，赶快去报名吧</div>
                </div>
            </template>
        </div>
        <div class="sidebar-action clearfix">
            <div v-if="!isGtqscz" class="counseling" @click="onChatHandler">
                <span v-clickReport="34272722" class="counseling__text">
                    <i class="icon iconfont icon-zixun"></i>咨询
                </span>
            </div>
            <!-- 课程停售 -->
            <template v-if="stopSaleStatus !== 0">
                <div class="apply-status">
                    <button
                        type="button"
                        class="apply-btn apply-btn__stop "
                    >
                        <span class="apply-btn__text">该课程已停止售卖</span>
                    </button>
                </div>
            </template>
            <template v-else>
                <!-- 公开课按钮状态变更  -->
                <template v-if="res.course_type == 1">
                    <!-- 可报名 -->
                    <template v-if="res.enroll_status == 1">
                        <!-- 已购买 -->
                        <div v-if="res.content_type == 1" class="apply-status">
                            <button
                                v-if="res.direct_play.action == 0 || isGtqscz"
                                type="button"
                                class="apply-btn apply-btn__already"
                                :class="{'disabled': isGtqscz}"
                                @click="onGotoStudyHandler(res)"
                            >
                                <span class="apply-btn__text">已预约</span>
                            </button>
                            <button
                                v-if="res.direct_play.action == 2"
                                v-clickReport="34272821"
                                type="button"
                                class="apply-btn apply-btn__already"
                                @click="() => {
                                    res.playback_day === -1 ? onGotoStudyHandler(res) :  onGotoPLaybackList_Y(res);
                                }"
                            >
                                <span class="apply-btn__text">{{res.playback_day === -1 ? '去上课' : '看回放'}}</span>
                            </button>
                            <button
                                v-if="res.direct_play.action == 1"
                                v-clickReport="34272821"
                                type="button"
                                class="apply-btn apply-btn__already"
                                @click="onGotoLiveHandler_Y(res)"
                            >
                                <span class="apply-btn__text">进行中</span>
                            </button>
                        </div>
                        <!-- 已购买 -->
                        <!-- 未购买 -->
                        <div v-if="res.content_type == 2" class="apply-status">
                            <button
                                v-if="+res.price_fen > 0"
                                type="button"
                                class="apply-btn apply-btn__can"
                                @click="showQrcodeHandler()"
                            >
                                <span class="apply-btn__text" style="font-size: 16px;">立即报名</span>
                            </button>
                            <button
                                v-else-if="res.direct_play.action == 0 || isGtqscz"
                                type="button"
                                class="apply-btn apply-btn__can"
                                :disabled="isFetching"
                                :class="{is_loading: isFetching}"
                                @click="orderHandler(res)"
                            >
                                <span class="apply-btn__text">立即预约</span>
                            </button>
                            <button
                                v-else-if="res.direct_play.action == 2"
                                type="button"
                                class="apply-btn apply-btn__can"
                                :disabled="isFetching"
                                :class="{is_loading: isFetching}"
                                @click="onGotoPLaybackList_N(res)"
                            >
                                <span class="apply-btn__text">看回放</span>
                            </button>
                            <button
                                v-else-if="res.direct_play.action == 1"
                                type="button"
                                class="apply-btn apply-btn__can"
                                :disabled="isFetching"
                                :class="{is_loading: isFetching}"
                                @click="onGotoLiveHandler_N(res)"
                            >
                                <span class="apply-btn__text">进行中</span>
                            </button>
                        </div>
                        <!-- 未购买 -->
                    </template>
                    <!-- 可报名 -->
                    <!-- 已报满，按钮置灰不可操作 -->
                    <div v-else class="apply-status">
                        <button type="button" class="apply-btn apply-btn__can apply-btn__can--disabled">
                            <span class="apply-btn__text">{{res.enroll_status_name || '已报满'}}</span>
                        </button>
                    </div>
                    <!-- 已报满，按钮置灰不可操作 -->
                </template>
                <!-- 公开课按钮状态变更  -->
                <!-- 正价课 -->
                <div v-if="res.course_type > 1" class="apply-status">
                    <button
                        v-if="res.content_type == 1"
                        v-clickReport="34272821"
                        type="button"
                        class="apply-btn apply-btn__already"
                        :class="{'disabled': isGtqscz}"
                        @click="onGotoStudyHandler(res)"
                    >
                        <span class="apply-btn__text">{{isGtqscz ? '已报名' : '去上课'}}</span>
                    </button>
                    <template v-else>
                        <!-- 判断是否能购买克瑞斯课程criss_course:true文字显示，按钮不能点击，false则相反 -->
                        <template v-if="res.content_type == 2 && res.enroll_status == 1">
                            <button
                                v-if="res.criss_course"
                                type="button"
                                class="apply-btn apply-btn__can"
                                @click="showQrcodeHandler()"
                            >
                                <span class="apply-btn__text">立即报名</span>
                            </button>
                            <button
                                v-else
                                v-clickReport="34272709"
                                type="button"
                                class="apply-btn apply-btn__can"
                                :class="{is_loading: isFetching}"
                                @click="showQrcodeHandler()"
                            >
                                <span class="apply-btn__text apply-btn__text_sign-up">立即报名</span>
                            </button>
                        </template>
                        <!-- 判断是否能购买克瑞斯课程 -->
                        <button
                            v-if="res.content_type == 2 && res.enroll_status == 2"
                            type="button"
                            class="apply-btn apply-btn__can apply-btn__can--disabled">
                            <span class="apply-btn__text">已报满</span>
                        </button>
                        <button
                            v-if="res.content_type == 2 && res.enroll_status == 3"
                            type="button"
                            class="apply-btn apply-btn__can apply-btn__can--disabled">
                            <span class="apply-btn__text">{{res.enroll_status_name || '已报满'}}</span>
                        </button>
                        <button
                            v-if="res.content_type == 2 && res.enroll_status == 4"
                            type="button"
                            class="apply-btn apply-btn__can apply-btn__can--disabled">
                            <span class="apply-btn__text">已报满</span>
                        </button>
                    </template>
                </div>
                <!-- 正价课 -->
            </template>
        </div>
        <Modal name="toApp" type="8" />
        <Modal name="otherBrowser" type="9" />
        <examPopup v-if="showExamPopup" :data="examdData" :res="res" />
        <chat :isShowChatPopup.sync="isShowChatPopup" />
    </div>
</template>
<script>
import {getOffset} from '@base/util/common';
import {mapState} from 'vuex';
import DetailShare from '@business/components/learn/DetailShare';
import Modal from '@business/components/study/Modal';
import api from '~/api';
import $Bus from '@base/plugins/EventBus';
import qs from 'qs';
import examPopup from '@business/components/common/ExamPopup';
import chat from '@/components/common/chat';
import BossPrice from '@business/components/learn/price/BossPrice';
import PromotionPrice from '@business/components/learn/price/PromotionPrice';
import UrgeInfo from '@business/components/learn/urge/index';
import {addOrderTagToParams} from '@base/constants/signUpPathSource';
import config from '~/environment';
import callBack from '@base/mixins/callBack';
import productAction from '@base/mixins/productAction';

const ADULT_TYPE = 2;
const MODAL_VIEW = 5311254562105344;


export default {
    name: 'DetailSidebar',
    components: {
        DetailShare,
        Modal,
        examPopup,
        chat,
        'boss-price': BossPrice,
        'promotion-price': PromotionPrice,
        'urge-info': UrgeInfo
    },
    mixins: [callBack, productAction],
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        },
        stopSaleStatus: {
            type: Number,
            default: 0
        },
        getCode: {
            type: Function
        }
    },
    data() {
        return {
            isFixed: false,
            offsetTop: 0,
            isFetching: false,
            // 分层考试number
            examNumber: '',
            // 分层考试提示弹框建议
            clazzSuggestion: '',
            showExamPopup: false,
            examdData: {},
            isShowChatPopup: false,
            adultType: ADULT_TYPE
        };
    },
    computed: {
        ...mapState({
            token: state => state.token,
            p_client: state => state.p_client
        }),
        ...mapState('course', {
            promotionUrgeInfo: state => state.promotionUrgeInfo
        }),
        utmData() {
            const utm_source = window.sessionStorage.getItem('utm_source') || '';
            const utm_term = window.sessionStorage.getItem('utm_term') || '';
            return {
                utm_source,
                utm_term
            };
        }
    },
    mounted() {
        // 公开课流程简化：当是公开课且未预约时
        // if (this.res.course_type === 1 && this.res.content_type === 2) {
        //     this.onOpenCourseBuyHandler(this.res)
        // }
        window.addEventListener('scroll', this.handleScroll);
        this.$nextTick(() => {
            const {detailSidebar} = this.$refs;
            if (detailSidebar && getOffset(detailSidebar) && getOffset(detailSidebar).top) {
                this.offsetTop = getOffset(detailSidebar).top - 30;
            }
        });
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        setExamdData() {
            this.examdData = {};
            this.showExamPopup = false;
        },
        handleScroll() {
            const scrollTop
                = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
            const scrollHeight
                = document.documentElement.scrollHeight
                    || document.body.scrollHeight;
            const clientHeight
                = document.documentElement.clientHeight
                    || document.body.clientHeight;
            this.isFixed = scrollTop > this.offsetTop && scrollHeight - clientHeight - scrollTop > 150;
        },
        onChatHandler() {
            if (this.p_client === 12) {
                this.caLearnDetailConsult();
                return;
            }
            this.isShowChatPopup = true;
        },
        onGotoStudyHandler(payload = {}) {
            if (this.isGtqscz) {
                return;
            }
            if (payload.course_type === 23) {
                if (this.p_client === 12) {
                    window.open(`https:${config.env.pcUrl}/account/study`);
                }
                else {
                    this.$router.push({path: '/account/study'});
                }
            }
            else {
                if (payload.direct_play && payload.direct_play.action === 1) {
                    // 快开课了直接进入直播间
                    // 提示打开直播客户端
                    this.$modal.show('toApp', {
                        live_status: 21,
                        live_id: payload.direct_play.live_id
                    });
                    // this.$store.dispatch('GET_LIVE_URL', {
                    //     live_id: payload.live_id
                    // });
                }
                else {
                    if (this.p_client === 12) {
                        window.open(`https:${config.env.pcUrl}/account/study?clazzNumber=${payload.course_id}`);
                    }
                    else {
                        this.$router.push({path: '/account/study?clazzNumber=' + payload.course_id});
                    }
                }
            }
        },
        // 立即预约点击事件
        orderHandler(payload) {
            // this.$toasted.show(
            //     '暂不支持购课！', {
            //         position: 'top-center',
            //         duration: 1500,
            //     }
            // );
            // return;
            // eslint-disable-next-line no-negated-condition
            if (!this.token) {
                this.$store.commit('SET_ISSHOWLOGIN', true);
                // 登录后未预约要自动预约并弹弹框
                $Bus.$emit('order');
            }
            else {
                const params = {
                    productId: payload.enroll_pid,
                    courseType: payload.course_type,
                    channel: 2,
                    checkNotPayOrder: true,
                    isFromH5: false,
                    utmData: this.utmData
                };
                const {counselor_id, seller_id, salesId, source} = this.$route.query;
                if (counselor_id) {
                    params.counselorId = counselor_id;
                }
                if (seller_id || salesId) {
                    params.sellerId = seller_id || salesId;
                    params.salesId = seller_id || salesId;
                }
                // 由于接口暂不支持统计 orderTagStr 相关字段的数据，增加参数后还报错，临时注释掉，等接口支持该参数统计后，再放开
                addOrderTagToParams(params);
                this.$axios.$post(api.order.createForFreeCourse, qs.stringify(params)).then(res => {
                    this.isFetching = false;
                    if (res.status === 0) {
                        if (this.p_client === 12) {
                            window.open(`https:${config.env.pcUrl}/apply/${payload.product_id}?courseType=${payload.course_type}&grade=${payload.grade}`);
                        }
                        else {
                            this.$router.push({
                                path: `/apply/${payload.product_id}`,
                                query: {
                                    courseType: payload.course_type,
                                    grade: payload.grade
                                }
                            });
                        }
                    }
                    if (res.status === 445) {
                        this.$habo.haboClickReport(MODAL_VIEW, {
                            source: '详情页报名'
                        });
                        this.$emit('handlePolling', {fn: this.getCode, grade: payload.grade, orderId: res.data.order_id});
                        this.$modal.show('apply-success-popup');
                    }
                });
            }
        },
        // 立即报名点击事件
        showQrcodeHandler() {
            // this.$toasted.show(
            //     '暂不支持购课！', {
            //         position: 'top-center',
            //         duration: 1500,
            //     }
            // );
            // return;
            this.$modal.show('apply-qrcode-popup');
        },
        // 已预约看回放
        onGotoPLaybackList_Y(payload) {
            if (this.token) {
                if (this.p_client === 12) {
                    window.open(`https:${config.env.pcUrl}/live/playbackList/${payload.live_id}?counselor_id=${this.$route.query.counselor_id}`);
                }
                else {
                    this.$router.push({
                        path: `/live/playbackList/${payload.live_id}`,
                        query: {
                            counselor_id: this.$route.query.counselor_id
                        }
                    });
                }
            }
            else if (!this.token) {
                this.$store.commit('SET_ISSHOWLOGIN', true);
                $Bus.$emit('autoPlay');
            }
        },
        // 未预约看回放
        onGotoPLaybackList_N(payload) {
            if (this.token) {
                this.$modal.show('countdown-popup');
                this.$emit('goGrdoupRecor');
            }
            else if (!this.token) {
                this.$store.commit('SET_ISSHOWLOGIN', true);
                $Bus.$emit('autoPlay');
            }
        },
        // 已预约直播中
        onGotoLiveHandler_Y(payload) {
            if (this.token) {
                this.$store.dispatch('GET_LIVE_URL', {
                    live_id: payload.direct_play.live_id,
                    action_type: payload.direct_play.action,
                    ...this.$route.query
                });
            }
            else if (!this.token) {
                this.$store.commit('SET_ISSHOWLOGIN', true);
                $Bus.$emit('autoPlay');
            }
        },
        // 未预约直播中
        onGotoLiveHandler_N(payload) {
            if (this.token) {
                this.$modal.show('countdown-popup');
                this.$emit('goGrdoupRecor');
            }
            else if (!this.token) {
                // 未登录直播中
                this.$store.commit('SET_ISSHOWLOGIN', true);
                $Bus.$emit('autoPlay');
            }
        },
        onEnrollHandler(payload) {
            this.showExamPopup = false;
            if (!this.token) {
                this.$store.commit('SET_ISSHOWLOGIN', true);
                return;
            }
            const {course_id, card_course_type, sub_clazz_list} = payload;
            let clazzNumberList = [];
            // 联报
            if (card_course_type === 23) {
                clazzNumberList = sub_clazz_list.map(item => item.clazz_number);
            }
            else {
                clazzNumberList.push(course_id);
            }
            // 判断是否是分层考试
            const examParams = {
                clazzNumberList
            };
            this.$axios
                .$post(api.order.judgeIsNeedExamBeforePay, examParams, {headers: {'Content-Type': 'application/json'}})
                .then(res => {
                    const {code, data = {}} = res;
                    if (code === 0) {
                        this.examdData = data;
                        const {examNumber, hasMoreThanOneExam} = this.examdData;
                        if (hasMoreThanOneExam || (+examNumber !== 0 && !hasMoreThanOneExam)) {
                            this.showExamPopup = true;
                            return;
                        }
                        const params = {
                            productId: payload.enroll_pid,
                            courseType: payload.course_type,
                            checkNotPayOrder: true,
                            isFromH5: false
                        };
                        if (this.$route.query.counselor_id) {
                            params.counselor_id = this.$route.query.counselor_id;
                        }
                        this.isFetching = true;
                        this.$axios.$get(api.order.canCreateOrder, {params}).then(res => {
                            this.isFetching = false;
                            if (res.status === 0) {
                                if (this.p_client === 12) {
                                    window.open(`https:${config.env.pcUrl}/apply/${params.productId}?courseType=${params.courseType}&grade=${payload.grade}`);
                                }
                                else {
                                    this.$router.push({
                                        path: `/apply/${params.productId}`,
                                        query: {
                                            courseType: params.courseType,
                                            grade: payload.grade
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
        }
    }
};
</script>
<style lang="less" scoped>
.disabled {
    cursor: default !important;
}
.detail-sidebar {
    position: relative;
    width: 258px;
    border: solid 1px #ebebeb;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 30px;

    &.is_fixed {
        position: fixed;
        top: 100px;
        z-index: 199;
    }
}

.sidebar-fever {
    position: relative;
    padding: 30px 0;

    &-left {
        float: left;
        position: relative;
    }

    em {
        font-style: normal;
    }
}

.sidebar-explain {
    position: relative;
    padding: 24px 0;
    font-size: 14px;
    color: #32404b;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;

    .service {
        padding-right: 12px;
    }

    .price {
        font-size: 20px;
        color: #f63232;
    }

    &__dl {
        position: relative;
        line-height: 26px;
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;

        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    &__dt {
        float: left;
        width: 42px;
    }

    &__dd {
        margin-left: 42px;

        &.criss {
            color: #f63232;
        }
    }
}

.sidebar-action {
    position: relative;
    padding: 20px 0 30px;

    .counseling {
        float: left;
        position: relative;

        &__text {
            display: block;
            width: 100px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #f63232;
            font-size: 20px;
            color: #f63232;
            cursor: pointer;
            transition: all .3s;

            .icon {
                font-size: 22px;
                padding-right: 5px;
            }

            &:hover {
                color: rgba(246, 50, 50, .6);
                border-color: rgba(246, 50, 50, .6);
            }
        }
    }

    .apply-status {
        float: right;

        .apply-btn {
            position: relative;
            width: 130px;
            height: 44px;
            text-align: center;
            border-radius: 4px;
            border: 1px solid #f63232;
            font-size: 20px;
            appearance: none;
            outline: none;
            margin: 0;
            padding: 0;
            user-select: none;
            transition: all .3s;

            &__can {
                background-color: #f63232;
                color: #fff;
                cursor: pointer;

                &.is_loading {
                    &:hover {
                        background-color: #ff4c52;
                    }

                    &:active {
                        background-color: #ff4c52;
                    }
                }

                &:hover {
                    background-color: #ff4c52;
                }

                &:active {
                    background-color: #e00;
                }

                &.criss_course {
                    background-color: #f96562;
                    border: 1px solid #f96562;
                    cursor: auto;
                }

                &--disabled {
                    background-color: #bfbfbf;
                    color: #fff;
                    border-color: #bfbfbf;
                    cursor: auto;

                    &:hover,
                    &:active {
                        background-color: #bfbfbf;
                        color: #fff;
                        border-color: #bfbfbf;
                    }
                }
            }

            &__already {
                background: rgba(246, 50, 50, 1);
                color: rgba(255, 255, 255, 1);
                cursor: pointer;
            }

            &__stop {
                background: #ebeff4;
                color: #c1c8d1;
                border:1px solid #c1c8d1;
                font-size: 15px;
            }
        }
    }
}
</style>
